import { render, staticRenderFns } from "./SeviceRatioChart.vue?vue&type=template&id=19d70f98&"
import script from "./SeviceRatioChart.vue?vue&type=script&lang=js&"
export * from "./SeviceRatioChart.vue?vue&type=script&lang=js&"
import style0 from "./SeviceRatioChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports